import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    sendStatus({ commit }, newBookingLine) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/sendStatus",
            data: newBookingLine,
            method: "POST"
          })
          .then(async (resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendBelatedStatus({ commit }, newBookingLine) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/sendBelatedStatus",
            data: newBookingLine,
            method: "POST"
          })
          .then(async (resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cancelStatus({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/cancelStatus",
            data: userId,
            method: "DELETE"
          })
          .then(async (resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    closeOpenBooking({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/closeOpenBooking",
            data: userId,
            method: "POST"
          })
          .then(async (resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },

  module: {},
  getters: {}
};
